import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { AppService } from '../../../services/app/app.service';
import { RestService } from '../../../services/rest/rest.service';
import { filter, map, Observable, take, tap } from 'rxjs';
import { Log } from 'app/core/logging/log';

@Injectable({
  providedIn: 'root'
})
export class IsLoggedInGuard implements CanLoad, CanActivate {

  constructor(private appService:AppService, private restService:RestService, private router:Router){
    
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    //console.log('canLoad');
    const attemptedUrl = '/' + segments.map(s => s.path).join('/');
    return this.hasLogged(attemptedUrl);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    Log.info('canActivate');
    return this.hasLogged(state.url);
  }



  hasLogged(returnUrl:string): Observable<boolean> | boolean {

    let hasToken:boolean = this.appService.getToken() != null;
    if(!hasToken){
      //console.log('no hay token');
      this.router.navigate(['/signin'], { queryParams: { returnUrl: returnUrl } });
      return false;
    }

    return this.appService.currentUser$.pipe(
      filter(user => user !== null), // espera hasta que no sea null
      map((user) => Boolean(user)),
      tap((isLoggedIn) => isLoggedIn === false && this.router.navigate(['/signin'], { queryParams: { returnUrl: returnUrl } })),
    );
  }

}
